import { html, css, LitElement } from 'lit';
import { StorageMixin } from './storage-mixin.js'

export class DzRangeSlider extends StorageMixin(LitElement) {

  static properties = {    
    min:    {type: Number, reflect: true},
    max:    {type: Number, reflect: true},
    store:  {type: String, store: true },
  };

  constructor() {
    super();
    this.min = 0
    this.max = 1
  }

  connectedCallback() {
    super.connectedCallback()
    if (this.store) {
      ({ min: this.min, max: this.max } = this.store)
    }
  }


  render() {
    let pt_min = (this.min * (this.offsetWidth - 14)) + 7  
    let pt_max = ((1-this.max) * (this.offsetWidth - 14)) + 7 
        
    let bg_min = `background: linear-gradient(90deg, #eee ${pt_min}px, rgba(0, 0, 0, 0) ${pt_min}px);`
    let bg_max = `background: linear-gradient(90deg, #eee ${pt_max}px, rgba(0, 0, 0, 0) ${pt_max}px);`
    
    return html` 
        <input part="min-input" class="min" type="range" min="0" max="1" step="0.01" @input="${this.minChanged}" .value="${this.min}" style="${bg_min}">
        <input part="max-input" class="max" type="range" min="0" max="1" step="0.01" @input="${this.maxChanged}" .value="${1 - this.max}" style="${bg_max}">
    `
  }

  fireEvent() {
    this.store = { min: this.min, max: this.max }
    let evt = new CustomEvent("input", {bubbles: true, composed: true, detail: {"min": this.min, "max": this.max}})
    this.dispatchEvent(evt)
  }

  minChanged(evt) {
    let new_min = Number(evt.target.value)
    if ((this.min - new_min) < 0) {
     let param = Math.min(1, Math.max(0, Math.abs(new_min - this.max) * 10))    
     this.max  = Math.min(this.max*param + (new_min + 0.1) * (1 - param), 1)  
    }
    this.min  = new_min
    this.fireEvent()
 
  }

  maxChanged(evt) {
    let new_max = 1 - Number(evt.target.value)
    if ((this.max - new_max) > 0) {
        let param = Math.min(1, Math.max(0, Math.abs(new_max - this.min) * 10))    
        this.min  = Math.max(this.min*param + (new_max - 0.1) * (1 - param), 0)  
    }
    this.max  = new_max 
    this.fireEvent()
  }

  static styles = css`
      
  :host {
    display: inline-block;
    position: relative;
    background: linear-gradient(0deg, #FFAC5F 0%, #FB5F01 17.19%, #FA7F00 62.07%, #FFB354 90.27%, #FA9600 95.54%);
    border-radius: var(--bar-height, 15px);
    width: 230px;
    height: var(--bar-height, 15px);
  }
  
  input {
    border-radius: 15px;
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0px;
    appearance: none;
    display: block;
    background: none;
    pointer-events: none;
  }
  
  input::-webkit-slider-thumb {
    appearance: none; 
    background: linear-gradient(-0deg, #FFAC5F 0%, #FB5F01 17.19%, #FA7F00 62.07%, #FFB354 90.27%, #FA9600 95.54%);
    width: calc(var(--bar-height, 15px) + 8px);
    height: calc(var(--bar-height, 15px) + 8px);
    border: solid 0px;
    border-radius: 50%;
    pointer-events: all;
    cursor: pointer;
    background: #FB5F01;
  }
  
  input::-webkit-slider-thumb:hover {
    outline: solid rgba(255, 138, 0, 0.4) 5px;
  }
  
  input::-webkit-slider-runnable-track {
    appearance: none;
  }
  
  input::-moz-range-thumb {
    appearance: none; 
    background: linear-gradient(-0deg, #FFAC5F 0%, #FB5F01 17.19%, #FA7F00 62.07%, #FFB354 90.27%, #FA9600 95.54%);
    width: var(--bar-height, 15px);
    height: var(--bar-height, 15px);
    border: solid 0px;
    border-radius: 50%;
    pointer-events: all;
    cursor: pointer;
  }
  
  input::-moz-range-thumb:hover {
    background: #FB5F01;
    outline: solid rgba(255, 138, 0, 0.28) 10px;
  }

  input.max {
    box-sizing: border-box;
    transform: scale(-1, 1);
  }
`

}


customElements.define('dz-range-slider', DzRangeSlider);